import React from "react";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
////// Mui
import { MenuItem, Typography } from "@mui/material";

const CSVLinkWrapper = (props) => {
  const { data, headers } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <MenuItem type='button' color='primary'>
        <CSVLink
          headers={headers}
          data={data()}
          filename={"export_data.csv"}
          style={{ textDecoration: "none", width: "100%" }}
          target='_blank'
          separator={";"}
          enclosingCharacter={``}
        >
          <Typography align='center'>{t("button.csv")}</Typography>
        </CSVLink>
      </MenuItem>
    </React.Fragment>
  );
};

export default CSVLinkWrapper;
